import React, { useEffect, useState } from 'react'
import PrivacyPolicyTemplate from './PrivacyPolicyTemplate'
import { API_BASE_URL } from 'configs/AppConfig';
import { useParams } from 'react-router-dom';
import MetaDetails from 'components/meta-details/MetaDetails';

function PrivacyPolicy() {

  const [list, setList] = useState()
  const {slug} = useParams();

  const fetchData = async () => {
    const response = await fetch(`${API_BASE_URL}information-policy/getBySlug/${slug}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    setList(data?.data);
    console.log('data pages', data)

    if (!response.ok) {
      // message.error(data.message);
      throw new Error(data.message);
    }

    
    // return data.data;
  }

  useEffect(()=>{
    fetchData()
  },[window.location.pathname])

  return (
    <div>
      <PrivacyPolicyTemplate title={list?.data?.title} data={list} />
    </div>
  )
}

export default PrivacyPolicy
